// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useMemo } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Button } from 'react-bootstrap';
import EventBookableOptions from './EventBookableOptions';
import EventBookableDate from './EventBookableDate';
import EventBookableAttendees from './EventBookableAttendees';

const EventBookableOrderForm = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  orderState,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  selectedActivity,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onOrderStateChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onEnterPaymentClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  party,
}) => {
  const eventDuration = useMemo(
    () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      let durationReturnValue = selectedActivity.duration || 60;
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      orderState.selectedBookingOptions.forEach(option => {
        const { duration } = option;
        if (duration && duration > durationReturnValue) {
          durationReturnValue = duration;
        }
      });
      return durationReturnValue;
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    [orderState.selectedBookingOptions.length]
  );

  return (
    <>
      <EventBookableOptions
        selectedActivity={selectedActivity}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        selectedBookingOptions={orderState.selectedBookingOptions}
        onOrderStateChange={onOrderStateChange}
      />
      <EventBookableDate
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        startDateTime={orderState.startDateTime}
        onOrderStateChange={onOrderStateChange}
        eventDuration={eventDuration}
      />
      <EventBookableAttendees
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        attendees={orderState.attendees}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        members={party.members}
        onOrderStateChange={onOrderStateChange}
      />
      <Button
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        disabled={orderState.selectedBookingOptions.length === 0}
        onClick={onEnterPaymentClick}
      >
        Enter Payment
      </Button>
    </>
  );
};

export default EventBookableOrderForm;
